import React from "react";
import { PaymentType } from "../../app/types/ProposalTypes";
import AlertModal from "../../components/organism/AlertModal";

const CheckoutPayment = ({
  data,
  depositAmount,
  remainingAmount,
}: {
  data: PaymentType[] | null;
  depositAmount?: number;
  remainingAmount?: number;
}) => {
  const [alertModalShow, setAlertModalShow] = React.useState<{
    open: boolean;
    children: React.ReactNode;
  }>({
    open: false,
    children: "",
  });

  const onClickPaymentTerms = (idx: number) => {
    const terms = data && data[idx] && data[idx].terms ? data[idx].terms : "";
    if (!terms) {
      return;
    }

    setAlertModalShow({
      open: true,
      children: <div dangerouslySetInnerHTML={{ __html: terms }} />,
    });
  };

  // Add this effect to attach the onClick handler to all dynamically created <a> elements
  React.useEffect(() => {
    const handleClick = (e: Event) => {
      e.preventDefault();

      const target = e.target as HTMLAnchorElement;
      if (target.tagName === "A" && target.dataset.idx) {
        onClickPaymentTerms(Number(target.dataset.idx));
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });

  const renderMethod = (method: PaymentType, idx: number) => {
    if (!method.payment_require) {
      return null;
    }

    switch (method.payment_system) {
      case 1:
        return renderStripe(method, idx);
      case 2:
        return renderPayex(method, idx);
      case 3:
        return renderBambora(method, idx);
      case 4:
        return renderNetsEasy(method, idx);
      case 5:
        return renderPlaner(method, idx);
      case 6:
        return renderDintero(method, idx);
      default:
        return null;
    }
  };

  const renderDintero = (method: PaymentType, idx: number) => {
    if (
      ["card_as_guarantee", "payment"].includes(String(method.payment_type))
    ) {
      return (
        <div
          key={`payment-methods-item-${idx}`}
          className="flex items-start bg-white border border-gray-300  mb-3 p-3"
        >
          <div>
            {/* <img
              src={`${window.location.origin}/img/dintero_logo.png`}
              alt="Dintero"
              className="h-7"
            /> */}
            <span className="font-semibold  text-gray-600 text-lg">
              Dintero
            </span>
            <p className="mt-2 mb-0">
              <div
                dangerouslySetInnerHTML={{
                  __html: (() => {
                    const text = String(
                      globalThis.translate.w.checkout_payment.p[
                        method.payment_type
                      ],
                    )
                      .replace(
                        ":amount",
                        `<b>${Number(method.payment_amount / 100).toFixed(
                          2,
                        )}</b>`,
                      )
                      .replace(":currency", `${method.currency}`);

                    if (method.terms) {
                      const parts = text.split(":terms");
                      return `${parts[0]} <a href="#" data-idx="${idx}">${globalThis.translate.w.checkout_payment.a.terms}</a>${parts[1]}`;
                    } else {
                      const parts = text.split(":terms");
                      return `${parts[0]} ${parts[1]}`;
                    }
                  })(),
                }}
              />
              <span>
                {remainingAmount !== undefined && remainingAmount > 0 && (
                  <>
                    <div className="text-lg font-normal">
                      {globalThis.translate.w.checkout_payment.remaining_amount.replace(
                        ":amount",
                        `${remainingAmount?.toFixed(2)}`,
                      )}
                    </div>
                  </>
                )}
              </span>
            </p>
          </div>
        </div>
      );
    }

    return null;
  };

  const renderBambora = (method: PaymentType, idx: number) => {
    if (method.payment_type === "payment") {
      return (
        <div
          key={`payment-methods-item-${idx}`}
          className="flex items-start bg-white border border-gray-300  mb-3 p-3"
        >
          <div>
            <img
              src={`${window.location.origin}/img/bambora_logo_dark.png`}
              alt="Bambora"
              className="h-7"
            />
            <p className="mt-2 mb-0">
              <div
                dangerouslySetInnerHTML={{
                  __html: (() => {
                    const text = String(
                      globalThis.translate.w.checkout_payment.p[
                        method.payment_type
                      ],
                    )
                      .replace(
                        ":amount",
                        `<b>${Number(method.payment_amount / 100).toFixed(
                          2,
                        )}</b>`,
                      )
                      .replace(":currency", `${method.currency}`);

                    if (method.terms) {
                      const parts = text.split(":terms");
                      return `${parts[0]} <a href="#" data-idx="${idx}">${globalThis.translate.w.checkout_payment.a.terms}</a>${parts[1]}`;
                    } else {
                      const parts = text.split(":terms");
                      return `${parts[0]} ${parts[1]}`;
                    }
                  })(),
                }}
              />
              <span>
                {remainingAmount !== undefined && remainingAmount > 0 && (
                  <>
                    <div className="text-lg font-normal">
                      {globalThis.translate.w.checkout_payment.remaining_amount.replace(
                        ":amount",
                        `${remainingAmount?.toFixed(2)}`,
                      )}
                    </div>
                  </>
                )}
              </span>
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderNetsEasy = (method: PaymentType, idx: number) => {
    if (
      ["card_as_guarantee", "payment"].includes(String(method.payment_type))
    ) {
      return (
        <div
          key={`payment-methods-item-${idx}`}
          className="flex items-start bg-white border border-gray-300  mb-3 p-3 "
        >
          <div>
            <img
              src={`${window.location.origin}/img/nets_logo.png`}
              alt="netseasy"
              className="h-10"
            />
            <div
              dangerouslySetInnerHTML={{
                __html: (() => {
                  const text = String(
                    globalThis.translate.w.checkout_payment.p[
                      `nets_${method.payment_type}`
                    ],
                  )
                    .replace(
                      ":amount",
                      `<b>${Number(method.payment_amount / 100).toFixed(2)}</b>`,
                    )
                    .replace(":currency", `${method.currency}`);

                  if (method.terms) {
                    const parts = text.split(":terms");
                    return `${parts[0]} <a href="#" data-idx="${idx}">${globalThis.translate.w.checkout_payment.a.terms}</a>${parts[1]}`;
                  } else {
                    const parts = text.split(":terms");
                    return `${parts[0]} ${parts[1]}`;
                  }
                })(),
              }}
            />
            <span>
              {remainingAmount !== undefined && remainingAmount > 0 && (
                <>
                  <div className="text-lg font-normal">
                    {globalThis.translate.w.checkout_payment.remaining_amount.replace(
                      ":amount",
                      `${remainingAmount?.toFixed(2)}`,
                    )}
                  </div>
                </>
              )}
            </span>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderPayex = (method: PaymentType, idx: number) => (
    <div
      key={`payment-methods-item-${idx}`}
      className="flex items-start bg-white border border-gray-300  mb-3 p-3"
    ></div>
  );

  const renderStripe = (method: PaymentType, idx: number) => {
    if (
      ["card_as_guarantee", "payment"].includes(String(method.payment_type))
    ) {
      return (
        <div
          key={`payment-methods-item-${idx}`}
          className="flex items-start bg-white border border-gray-300  mb-3 p-3"
        >
          <div>
            <img
              src={`${window.location.origin}/img/stripe_logo_dark.svg`}
              alt="Stripe"
              className="h-12 relative -left-3"
            />
            <p className="mt-0 mb-0">
              <div
                dangerouslySetInnerHTML={{
                  __html: (() => {
                    const text = String(
                      globalThis.translate.w.checkout_payment.p[
                        method.payment_type
                      ],
                    )
                      .replace(
                        ":amount",
                        `<b>${Number(method.payment_amount / 100).toFixed(
                          2,
                        )}</b>`,
                      )
                      .replace(":currency", `${method.currency}`);

                    if (method.terms) {
                      const parts = text.split(":terms");
                      return `${parts[0]} <a href="#" data-idx="${idx}">${globalThis.translate.w.checkout_payment.a.terms}</a>${parts[1]}`;
                    } else {
                      const parts = text.split(":terms");
                      return `${parts[0]} ${parts[1]}`;
                    }
                  })(),
                }}
              />
              <span>
                {remainingAmount !== undefined && remainingAmount > 0 && (
                  <>
                    <div className="text-lg font-normal">
                      {globalThis.translate.w.checkout_payment.remaining_amount.replace(
                        ":amount",
                        `${remainingAmount?.toFixed(2)}`,
                      )}
                    </div>
                  </>
                )}
              </span>
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderPlaner = (method: PaymentType, idx: number) => {
    if (
      ["card_as_guarantee", "payment"].includes(String(method.payment_type))
    ) {
      return (
        <div
          key={`payment-methods-item-${idx}`}
          className="flex items-start bg-white border border-gray-300 mb-3 p-3"
        >
          <div>
            <img
              src={`${window.location.origin}/img/planet_logo.png`}
              alt="Planet"
              className="h-12 relative -left-3"
            />
            <p className="mt-0 mb-0">
              <div
                dangerouslySetInnerHTML={{
                  __html: (() => {
                    const text = String(
                      globalThis.translate.w.checkout_payment.p[
                        method.payment_type
                      ],
                    )
                      .replace(
                        ":amount",
                        `<b>${Number(method.payment_amount / 100).toFixed(
                          2,
                        )}</b>`,
                      )
                      .replace(":currency", `${method.currency}`);

                    if (method.terms) {
                      const parts = text.split(":terms");
                      return `${parts[0]} <a href="#" data-idx="${idx}">${globalThis.translate.w.checkout_payment.a.terms}</a>${parts[1]}`;
                    } else {
                      const parts = text.split(":terms");
                      return `${parts[0]} ${parts[1]}`;
                    }
                  })(),
                }}
              />
              <span>
                {remainingAmount !== undefined && remainingAmount > 0 && (
                  <>
                    <div className="text-lg font-normal">
                      {globalThis.translate.w.checkout_payment.remaining_amount.replace(
                        ":amount",
                        `${remainingAmount?.toFixed(2)}`,
                      )}
                    </div>
                  </>
                )}
              </span>
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  if (!data) {
    return null;
  }

  return (
    <div className="payment-methods">
      <h5 className="text-lg font-semibold mb-4">
        {globalThis.translate.w["checkout_payment.h5_head"]}
      </h5>
      {data.map((item, idx) => renderMethod(item, idx))}

      <AlertModal
        open={alertModalShow.open}
        children={alertModalShow.children}
        onClose={() => setAlertModalShow({ ...alertModalShow, open: false })}
      />
    </div>
  );
};

export default CheckoutPayment;
